'use client';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  ThemeProvider,
  createTheme,
} from '@mui/material';
import React from 'react';

import { isNonEmptyArray } from 'utils/functions';

import type { FC } from 'react';

interface FormCheckBoxProps {
  label?: string;
  values: { [key: string]: boolean };
  options?: { value?: string; label?: string; id?: string }[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckBoxGroup: FC<FormCheckBoxProps> = ({ label, values, options, onChange }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event);
  };

  const theme = createTheme({
    palette: {
      primary: {
        light: '#5095a4',
        main: '#24272A',
        dark: '#000000',
        contrastText: '#ffffff',
      },
      secondary: {
        light: '#5f5f5f',
        main: '#353535',
        dark: '#0f0f0f',
        contrastText: '#ffffff',
      },
    },
    typography: {
      fontFamily: [
        'acumin-pro-semi-condensed',
        '-apple-system',
        'system-ui',
        'SegoeUI',
        'Roboto',
        'Oxygen',
        'Ubuntu',
        'Cantarell',
        'Fira Sans',
        'Droid Sans',
        'Helvetica Neue',
        'sans-serif',
      ].join(','),
      fontSize: 25,
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <FormControl component="fieldset">
        <FormLabel component="legend">{label}</FormLabel>
        <FormGroup row sx={{ marginTop: '10px' }}>
          {isNonEmptyArray(options) &&
            options.map(option => (
              <FormControlLabel
                key={option.label}
                control={
                  <Checkbox
                    name={option.value}
                    id={option.id}
                    checked={Boolean(values[option.value || ''])}
                    onChange={handleChange}
                    color="primary"
                  />
                }
                label={option.label}
              />
            ))}
        </FormGroup>
      </FormControl>
    </ThemeProvider>
  );
};

export default CheckBoxGroup;
